import React, { Component } from "react";
import { Icon } from "@iconify/react";
import pythonIcon from "@iconify/icons-logos/python";
import reactIcon from "@iconify/icons-logos/react";
import javaIcon from "@iconify/icons-logos/java";
import linkedinIcon from "@iconify/icons-mdi/linkedin";

class About extends Component {
  render() {
    const { sharedBasicInfo, resumeBasicInfo } = this.props;

    // Safely extract values
    const profilepic = sharedBasicInfo?.image || "images/default.jpg";
    const sectionName = resumeBasicInfo?.section_name?.about || "About Me";
    const hello = resumeBasicInfo?.description_header || "Hello";
    const about = resumeBasicInfo?.description || "";

    return (
      <section id="about">
        <div className="col-md-12">
          <h1 style={{ color: "black" }}>
            <span>{sectionName}</span>
          </h1>
          <div className="row center mx-auto mb-5">
            <div className="col-md-4 mb-5 center">
              <div className="polaroid">
                <span style={{ cursor: "auto" }}>
                  <img
                    height="250px"
                    src={process.env.PUBLIC_URL + "/" + profilepic}
                    alt="Profile"
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src =
                        process.env.PUBLIC_URL + "/images/default.jpg";
                    }}
                  />
                  <Icon
                    icon={pythonIcon}
                    style={{ fontSize: "400%", margin: "9% 5% 0 5%" }}
                  />
                  <Icon
                    icon={reactIcon}
                    style={{ fontSize: "400%", margin: "9% 5% 0 5%" }}
                  />
                  <Icon
                    icon={javaIcon}
                    style={{ fontSize: "400%", margin: "9% 5% 0 5%" }}
                  />
                </span>
              </div>
            </div>

            <div className="col-md-8 center">
              <div className="col-md-10">
                <div className="card">
                  <div className="card-header">
                    <span
                      className="iconify"
                      data-icon="emojione:red-circle"
                      data-inline="false"
                    ></span>{" "}
                    &nbsp;
                    <span
                      className="iconify"
                      data-icon="twemoji:yellow-circle"
                      data-inline="false"
                    ></span>{" "}
                    &nbsp;
                    <span
                      className="iconify"
                      data-icon="twemoji:green-circle"
                      data-inline="false"
                    ></span>
                  </div>
                  <div
                    className="card-body font-trebuchet text-justify ml-3 mr-3"
                    style={{
                      height: "auto",
                      fontSize: "140%",
                      lineHeight: "200%",
                    }}
                  >
                    <br />
                    <span className="wave">{hello} :)</span>
                    <br />
                    <br />
                    {about}
                    <div className="text-center mt-4">
                      <a
                        href="https://www.linkedin.com/in/jerinalour"
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{
                          fontSize: "120%",
                          color: "#0e76a8",
                          textDecoration: "none",
                        }}
                      >
                        <Icon
                          icon={linkedinIcon}
                          style={{ fontSize: "150%", marginRight: "8px" }}
                        />
                        Connect with me on LinkedIn
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default About;
